const tabs = {
    actions: 'Actions',
    get_started: '開始上手',
    dashboard: '儀表板',
    applications: '全部應用',
    api_resources: 'API 資源',
    sign_in_experience: '登錄與帳戶',
    connectors: '連接器',
    enterprise_sso: '企業SSO',
    security: '安全',
    webhooks: 'Webhooks',
    organizations: '組織',
    users: '用戶管理',
    audit_logs: '審計日誌',
    roles: '角色',
    docs: '文檔',
    tenant_settings: '租戶設置',
    mfa: '多重認證',
    customize_jwt: '自定義 JWT',
    signing_keys: '簽署密鑰',
    organization_template: '組織模板',
};
export default Object.freeze(tabs);
